"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationsInfo = exports.NotificationsContent = exports.TouchableOpacityBtn = exports.NotificationsHeader = exports.NotificationsTitle = exports.Notifications = void 0;
const native_1 = __importDefault(require("styled-components/native"));
const notificationBorder = (notificationsBorderProps) => {
    switch (notificationsBorderProps.type) {
        case 'Success':
            return `1px solid ${notificationsBorderProps.theme.notification.border.success}`;
        case 'Primary':
        default:
            return `1px solid ${notificationsBorderProps.theme.notification.border.primary}`;
    }
};
const notificationsBackgroundColor = (notificationsBgProps) => {
    switch (notificationsBgProps.type) {
        case 'Success':
            return notificationsBgProps.theme.notification.background.success;
        case 'Primary':
        default:
            return notificationsBgProps.theme.notification.background.primary;
    }
};
const notificationsContentColor = (notificationsContentProps) => {
    switch (notificationsContentProps.type) {
        case 'Success':
            return notificationsContentProps.theme.notification.content.success;
        case 'Primary':
        default:
            return notificationsContentProps.theme.notification.content.primary;
    }
};
exports.Notifications = native_1.default.View `
  width: 100%;
  position: absolute;
  bottom: 92px;
  padding: 12px;
`;
exports.NotificationsTitle = native_1.default.Text `
  font-size: 18px;
  line-height: 32px;
  color: ${(notificationsContentProps) => notificationsContentColor(notificationsContentProps)};
`;
exports.NotificationsHeader = native_1.default.View `
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
  padding-right: 12px;
`;
exports.TouchableOpacityBtn = native_1.default.TouchableOpacity `
  color: white;
`;
exports.NotificationsContent = native_1.default.View `
  width: 100%;
  padding: 12px;
  border-radius: 3px;
  overflow: hidden;
  background-color: ${(notificationsBgProps) => notificationsBackgroundColor(notificationsBgProps)};
  shadow-offset: 0 0;
  shadow-opacity: 0.11;
  shadow-radius: 6px;
  shadow-color: 'rgb(0,0,0)';
  elevation: 10;
  border: ${(notificationsBorderProps) => notificationBorder(notificationsBorderProps)};
`;
exports.NotificationsInfo = native_1.default.Text `
  padding: 0px;
  font-family: 'Roboto-Regular';
  line-height: 23px;
  font-size: 13px;
  color: ${(notificationsContentProps) => notificationsContentColor(notificationsContentProps)};
`;
